import React from "react";
import { useRouter } from "next/router";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";

// Global CSS imports (Next.js standard)
import '../index.css';
import '../styles/Navbar.css';
import '../styles/HeroSection.css';
import '../styles/AboutSection.css';
import '../styles/ServicesSection.css';
import '../styles/ProjectsSection.css';
import '../styles/QuoteForm.css';
import '../styles/IndustriesSection.css';
import '../styles/DesireTechSection.css';
import '../styles/ModelsSection.css';
import '../styles/CompareQualitySection.css';
import '../styles/BestArchitectureSection.css';
import '../styles/ClientsSection.css';
import '../styles/service/ServiceHero.css';
import '../styles/service/Development.css';
import '../styles/service/ServiceArchitecture.css';
import '../styles/service/ServiceChoose.css';
import '../styles/service/ServiceTrusted.css';
import '../styles/service/ServiceCloud.css';
import '../styles/service/ServiceExperienced.css';
import '../styles/service/ServiceAsbuilt.css';
import '../styles/service/ServiceExplore.css';
import '../styles/service/ServiceHiring.css';
import '../styles/ContactUsPage.css';
import '../styles/ContactUsPageForm.css';
import '../styles/service/ServiceOurMapBim.css';
import '../styles/Hire/HireOnDemand.css';
import '../styles/Hire/HireTable.css';
import '../styles/Hire/HirededicatedBIMmodelers.css';
import '../styles/Hire/HireAdvantages.css';
import '../styles/casestudy/casestudy.css';
import '../styles/casestudy/casestudy2.css';
import '../styles/casestudy/casestudyaddress.css';
import '../styles/casestudy/casestudy2section3.css';
import '../styles/casestudy/casestudy2Articles.css';
import '../styles/service/serviceBenifits.css';
import '../styles/service/serviceserving.css';
import '../styles/aboutus/aboutus4.css';
import '../styles/aboutus/aboutus5.css';
import '../styles/aboutus/aboutus6.css';
import '../styles/aboutus/aboutus7.css';
import '../styles/aboutus/aboutus8.css';
import '../styles/aboutus/aboutus9.css';
import '../styles/service/ScanToCadHero.css';
import '../styles/service/ScanToCad4.css';
import '../styles/service/ScanToCad5.css';
import '../styles/service/CadDrafting.css';
import '../styles/service/CadDraftingProcess.css';
import '../styles/service/CadDraftingIndustries.css';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const isAdminPage = router.pathname.startsWith('/admin');

  return (
    <div className="app-container">
      {!isAdminPage && <Navbar />}
      <Component {...pageProps} />
      {!isAdminPage && <Footer />}
    </div>
  );
}

export default MyApp;
